import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/data")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);

const PackedBubbleChart = ({ options, height }) => {
  return (
    <div style={{ width: "100%" }}>
      <HighchartsReact
        containerProps={{ style: { height: height || "80vh" } }}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};

export default PackedBubbleChart;
